module.exports = __webpack_public_path__ + "media/images/yesbank_green_smiley-eadefb0c50bdbc69006f635d6a5c99a1.svg";